export enum EMetaStatus {
    PENDENTE = 'Pendente',
    EM_ANDAMENTO = 'Em andamento',
    EM_REANALISE = 'Em reanálise',
    CONCLUIDO = 'Concluído',
    CANCELADO = 'Cancelado',
}

export interface IReqMunicipioContrato {
    estadoId: number
    estadoNome: string
    estadoSigla: string
    id: number
    nome: string
    uf: string
    uuid: string
}

export interface IMunicipio {
    uuid: string,
    id: number
    nome: string,
    estado: string,
    idIbge: number,
    active?: boolean
}

export interface IPlanoGovernoEixo {
    uuid: string;
    descricao: string;
    objetivo?: string;
    metas: IPlanoGovernoEixoMeta[];
}

export interface IPlanoGovernoAnexo {
    uuid: string;
    nome: string;
    arquivo: string;
}

export interface IPlanoGovernoEixoForm {
    descricao: string;
    objetivo?: string;
    idIbge: number;
    uuid?: string;
}

export interface IPlanoGovernoAnexoForm {
    nome: string;
    arquivo: File;
    idibge: string;
    uuid?: string;
}

export interface IPlanoGovernoAnexoCreate {
    nome: string;
    arquivo: File;
    idibge: string;
}

export interface IPlanoGovernoAnexoUpdate {
    nome: string;
    arquivo: File;
}


export interface IPlanoGovernoEixoCreate {
    descricao: string;
    objetivo?: string;
    idIbge: number;
}

export interface IPlanoGovernoEixoUpdate {
    descricao: string;
    objetivo?: string;
}

export interface IPlanoGovernoEixoMeta {
    uuid: string;
    descricao: string;
    objetivo: string;
    dataConclusao: string;
    dataPrevistaConclusao: string;
    porcentagemConclusao: number;
    status: EMetaStatus;
    eixoUuid: string;
    createdAt: string;
    updatedAt: string;
}

export interface IPlanoGovernoMetaForm {
    descricao: string;
    objetivo?: string;
    porcentagemConclusao?: number;
    status?: EMetaStatus;
    prioridade: "Baixa" | "Normal" | "Alta";
    responsavel?: string;
    impactoSocial?: string;
    valorEstimado?: string;
    valorGasto?: string;
    observacoes?: string;
    dataConclusao?: Date | string;
    dataPrevistaConclusao?: Date | string;
    eixoUuid: string;
    uuid?: string;
}


export interface IPlanoGovernoMetaCreate {
    descricao: string;
    objetivo?: string;
    porcentagemConclusao?: number;
    status?: EMetaStatus;
    prioridade: "Baixa" | "Normal" | "Alta";
    responsavel?: string;
    impactoSocial?: string;
    valorEstimado?: string;
    valorGasto?: string;
    observacoes?: string;
    dataConclusao?: Date | string;
    eixoUuid: string;
}

export interface IPlanoGovernoMetaUpdate {
    descricao: string;
    objetivo?: string;
    porcentagemConclusao?: number;
    status?: EMetaStatus;
    prioridade: "Baixa" | "Normal" | "Alta";
    responsavel?: string;
    impactoSocial?: string;
    valorEstimado?: string;
    valorGasto?: string;
    observacoes?: string;
    dataConclusao?: Date | string;
}

export interface IPlanoGovernoMetaDetalhes {
    uuid: string;
    descricao: string;
    objetivo: string;
    porcentagemConclusao: number;
    status: EMetaStatus;
    prioridade: "Baixa" | "Normal" | "Alta";
    responsavel: string;
    impactoSocial: string;
    valorEstimado: string;
    valorGasto: string;
    created_at: string;
    updated_at: string;
    dataConclusao: string;
    dataPrevistaConclusao: string;
    historico: IPlanoGovernoMetaHistorico[];
}

export interface IPlanoGovernoMetaHistorico {
    uuid: string;
    action: 'create' | 'update' | 'delete' | 'read';
    description: string,
    created_at: string,
    user: {
        "uuid": string,
        "name": string
    }
}
